"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountResponseToJSON = exports.AdAccountResponseFromJSONTyped = exports.AdAccountResponseFromJSON = exports.instanceOfAdAccountResponse = void 0;
var runtime_1 = require("../runtime");
var AdAccountBillingType_1 = require("./AdAccountBillingType");
var AdAccountRole_1 = require("./AdAccountRole");
var AdAccountStatus_1 = require("./AdAccountStatus");
var AdAccountTaxResponseObject_1 = require("./AdAccountTaxResponseObject");
var AdAccountTaxStatus_1 = require("./AdAccountTaxStatus");
var BillingAddress_1 = require("./BillingAddress");
var InternalAdAccountResponse_1 = require("./InternalAdAccountResponse");
/**
 * Check if a given object implements the AdAccountResponse interface.
 */
function instanceOfAdAccountResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAccountResponse = instanceOfAdAccountResponse;
function AdAccountResponseFromJSON(json) {
    return AdAccountResponseFromJSONTyped(json, false);
}
exports.AdAccountResponseFromJSON = AdAccountResponseFromJSON;
function AdAccountResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'businessId': !(0, runtime_1.exists)(json, 'business_id') ? undefined : json['business_id'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'countryCode': !(0, runtime_1.exists)(json, 'country_code') ? undefined : json['country_code'],
        'industry': !(0, runtime_1.exists)(json, 'industry') ? undefined : json['industry'],
        'website': !(0, runtime_1.exists)(json, 'website') ? undefined : json['website'],
        'billingAddress': !(0, runtime_1.exists)(json, 'billing_address') ? undefined : (0, BillingAddress_1.BillingAddressFromJSON)(json['billing_address']),
        'billingType': !(0, runtime_1.exists)(json, 'billing_type') ? undefined : (0, AdAccountBillingType_1.AdAccountBillingTypeFromJSON)(json['billing_type']),
        'legalEntityName': !(0, runtime_1.exists)(json, 'legal_entity_name') ? undefined : json['legal_entity_name'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AdAccountStatus_1.AdAccountStatusFromJSON)(json['status']),
        'statusReason': !(0, runtime_1.exists)(json, 'status_reason') ? undefined : json['status_reason'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'adAccountRole': !(0, runtime_1.exists)(json, 'ad_account_role') ? undefined : (0, AdAccountRole_1.AdAccountRoleFromJSON)(json['ad_account_role']),
        'taxId': !(0, runtime_1.exists)(json, 'tax_id') ? undefined : json['tax_id'],
        'taxStatus': !(0, runtime_1.exists)(json, 'tax_status') ? undefined : (0, AdAccountTaxStatus_1.AdAccountTaxStatusFromJSON)(json['tax_status']),
        'taxIds': !(0, runtime_1.exists)(json, 'tax_ids') ? undefined : (json['tax_ids'].map(AdAccountTaxResponseObject_1.AdAccountTaxResponseObjectFromJSON)),
        'currencyCode': !(0, runtime_1.exists)(json, 'currency_code') ? undefined : json['currency_code'],
        'internal': !(0, runtime_1.exists)(json, 'internal') ? undefined : (0, InternalAdAccountResponse_1.InternalAdAccountResponseFromJSON)(json['internal']),
    };
}
exports.AdAccountResponseFromJSONTyped = AdAccountResponseFromJSONTyped;
function AdAccountResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'business_id': value.businessId,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'country_code': value.countryCode,
        'industry': value.industry,
        'website': value.website,
        'billing_address': (0, BillingAddress_1.BillingAddressToJSON)(value.billingAddress),
        'billing_type': (0, AdAccountBillingType_1.AdAccountBillingTypeToJSON)(value.billingType),
        'legal_entity_name': value.legalEntityName,
        'status': (0, AdAccountStatus_1.AdAccountStatusToJSON)(value.status),
        'status_reason': value.statusReason,
        'name': value.name,
        'ad_account_role': (0, AdAccountRole_1.AdAccountRoleToJSON)(value.adAccountRole),
        'tax_id': value.taxId,
        'tax_status': (0, AdAccountTaxStatus_1.AdAccountTaxStatusToJSON)(value.taxStatus),
        'tax_ids': value.taxIds === undefined ? undefined : (value.taxIds.map(AdAccountTaxResponseObject_1.AdAccountTaxResponseObjectToJSON)),
        'currency_code': value.currencyCode,
        'internal': (0, InternalAdAccountResponse_1.InternalAdAccountResponseToJSON)(value.internal),
    };
}
exports.AdAccountResponseToJSON = AdAccountResponseToJSON;
